"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadReader = exports.FileUploadReader = exports.UniversalFileUploadReader = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var UniversalFileUploadReader = /** @class */ (function () {
    function UniversalFileUploadReader(file, field) {
        this.buffer = null;
        this.isFailed = false;
        this.isLoading = true;
        this.name = file.name;
        this.type = file.type;
        this.size = file.size;
        this.field = field;
        this.fileReader = new FileReader();
        this.fileReader.onerror = this.onFileError;
        this.fileReader.onload = this.onFileLoad;
        this.fileReader.readAsArrayBuffer(file);
    }
    UniversalFileUploadReader.prototype.onFileError = function () {
        this.fileReader.abort();
        this.isFailed = true;
        this.isLoading = false;
    };
    UniversalFileUploadReader.prototype.onFileLoad = function () {
        this.isFailed = false;
        this.isLoading = false;
        this.buffer = this.fileReader.result;
        this.fileReader = null;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], UniversalFileUploadReader.prototype, "buffer", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UniversalFileUploadReader.prototype, "isFailed", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UniversalFileUploadReader.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], UniversalFileUploadReader.prototype, "onFileError", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], UniversalFileUploadReader.prototype, "onFileLoad", null);
    return UniversalFileUploadReader;
}());
exports.UniversalFileUploadReader = UniversalFileUploadReader;
var FileUploadReader = /** @class */ (function (_super) {
    tslib_1.__extends(FileUploadReader, _super);
    function FileUploadReader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FileUploadReader;
}(UniversalFileUploadReader));
exports.FileUploadReader = FileUploadReader;
var ImageUploadReader = /** @class */ (function (_super) {
    tslib_1.__extends(ImageUploadReader, _super);
    function ImageUploadReader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ImageUploadReader;
}(UniversalFileUploadReader));
exports.ImageUploadReader = ImageUploadReader;
//# sourceMappingURL=upload.reader.js.map